import {ProtectedRoute} from "../../common/route/ProtectedRoute";

export const ClientRoute = ({ children }: { children: React.ReactNode }) => {
    return (
        <ProtectedRoute allowedRoles={['CLIENT']}>
            {children}
        </ProtectedRoute>
    );
};